import { BrowserRouter, Routes, Route } from "react-router-dom";
import usePushNotifications from "./hooks/usePushNotifications";

import RootLayout from "./pages/Root";
import ErrorPage from "./pages/Error";
import HomePage from "./pages/Home";
import DashboardPage from "./pages/Dashboard";
import FilePage from "./pages/File";
import FolderPage from "./pages/Folder";
import SchedaPsicologoPage from "./pages/SchedaPsicologo";
import Auth from "./pages/Auth";
import BillingPage from "./pages/Billing";
import ProtectedRoute from "./routes/ProtectedRoute";
import { AuthProvider } from "./store/auth-context";
import { ModalProvider } from "./store/modal-context";
import { NotificationProvider } from "./store/notification-context";
import PaymentSuccess from "./pages/PaymentSuccess";
import { UserProvider } from "./store/user-context";
import ModalHost from "./components/modals/ModalHost";
import NotificationHost from "./components/notifications/NotificationHost";

function PushNotificationsInitializer() {
    usePushNotifications();
    return <></>
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <UserProvider>
                    <NotificationProvider>
                        <ModalProvider>
                            <PushNotificationsInitializer />
                            <ModalHost />
                            <NotificationHost />
                            <Routes>
                                <Route path="/" element={<RootLayout />}>
                                    <Route element={<ProtectedRoute />}>
                                        <Route index element={<HomePage />} />
                                        <Route path="dashboard" element={<DashboardPage />} />
                                        <Route path="folder/:folderId" element={<FolderPage />} />
                                        <Route path="file/:fileId" element={<FilePage />} />
                                        <Route path="scheda-psicologo" element={<SchedaPsicologoPage />} />
                                        <Route path="billing" element={<BillingPage />} />
                                    </Route>
                                    <Route path="*" element={<ErrorPage />} />
                                </Route>
                                <Route path="auth" element={<Auth />} />
                                <Route path="billing/success" element={<PaymentSuccess />} />
                                <Route path="verify-email/:token" element={<Auth status='email_verification' />} />
                            </Routes>
                        </ModalProvider>
                    </NotificationProvider>
                </UserProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
